import api from 'api';
import DesignTemplate from 'records/DesignTemplate';

export const CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const CLEAN_SIMPLE_DESIGN_TEMPLATES_RESET_STATE = 'CLEAN_SIMPLE_DESIGN_TEMPLATES_RESET_STATE';

function cleanSimpleDesignTemplatesAsyncActionStart() {
  return {
    type: CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function cleanSimpleDesignTemplatesAsyncActionError(error) {
  return {
    type: CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function cleanSimpleDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: CLEAN_SIMPLE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetcleanSimpleDesignTemplatesState() {
  return {
    type: CLEAN_SIMPLE_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getcleanSimpleDesignTemplates(designTypeId, designSizeId, layoutId ) {
  return (dispatch, getState) => {
    dispatch(cleanSimpleDesignTemplatesAsyncActionStart());
    return api.request(
      `theme/design/DesignTemplates?themeid=0&designtid=${ designTypeId }&sizeid=${ designSizeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(cleanSimpleDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(cleanSimpleDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}


export function getcleanSimpleThemeDesignTemplates(layoutId) {
  return (dispatch, getState) => {
    dispatch(cleanSimpleDesignTemplatesAsyncActionStart());
    return api.request(
      `theme/design/DesignTemplates?themeid=0&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(cleanSimpleDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(cleanSimpleDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function filtercleanSimpleDesignTemplates(designTypeId, designSizeId,layoutId) {
  return (dispatch, getState) => {
    dispatch(cleanSimpleDesignTemplatesAsyncActionStart());
    let tmpDesignData = getState().cleanSimpleDesignTemplates.get('data');
    let filterData = DesignTemplate.getDesignTemplatesByTypeAndSizeId(tmpDesignData, designTypeId, designSizeId);

    let filterLayoutData = filterData;
    if(layoutId!=undefined){
      filterLayoutData=DesignTemplate.getDesignTemplatesByLayoutId(filterData, layoutId);
    }
    if(filterLayoutData.size==0){
      dispatch(getcleanSimpleDesignTemplates(designTypeId, designSizeId,layoutId));
    }else{
      dispatch(resetcleanSimpleDesignTemplatesState());
      dispatch(cleanSimpleDesignTemplatesAsyncActionSuccess(filterLayoutData));
    }
  };
}
